import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaSlotRemovalData, IRotaSlotRemovalResponse } from "@/api_framework/api_modals/Rota";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => { });

export interface IUseRotaSlotRemovalsListParams {
  staff_id: string;
  clinic_id: string;
  date: string;
}

export const useRotaSlotRemovalsListAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [loading, setLoading] = useState<boolean>(false);

  const execute = useCallback(
    async (params: IUseRotaSlotRemovalsListParams): Promise<IRotaSlotRemovalData[]> => {
      setLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const urlParams = new URLSearchParams();
        if (params.staff_id) urlParams.set("staff_id", params.staff_id);
        if (params.clinic_id) urlParams.set("clinic_id", params.clinic_id);
        if (params.date) urlParams.set("date", params.date);

        const res: AxiosResponse<IRotaSlotRemovalResponse> = await axios.get(
          ROTA_APIS?.ROTA_SLOT_REMOVALS?.baseURL ?? "",
          {
            params: urlParams,
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (res.data.status === true) {
          return res.data.data ?? [];
        } else {
          toast.error(res.data.message || "Failed to fetch slot removals");
          return [];
        }
      } catch (error: any) {
        if (axios.isAxiosError(error)) {
          sendCurl?.(error.config?.["curlCommand"]);
          toast.error("Error: " + (error.response?.data?.message || error.message));
        } else {
          toast.error("Server Error: " + error.message);
        }
        return [];
      } finally {
        setLoading(false);
      }
    },
    [configuration, sendCurl]
  );

  return { execute, loading };
};
